import type { Enums } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getTransactionTypeIcon(type: Enums<"transactionType">): IconName {
	switch (type) {
		case "correction":
			return "ArrowRightLeft";
		case "pick":
			return "ArrowRightToLine";
		case "inventory":
			return "ArrowUp10";
		case "restock":
			return "RefreshCcwDot";
		case "return":
			return "ArrowLeftToLine";
	}
}
